import { ColorToken } from '@backrs_ui/common-ui/src/designSystem/colors/colors';
import { AppIcon, ICON_SIZES, AppIcons } from '@backrs_ui/common-ui/src/designSystem/icons/AppIcon';

import { Box, SxProps, Theme } from '@mui/material';

export type BadgeIconProps = Readonly<{
  backgroundColor?: ColorToken;
  iconColor?: ColorToken;
  icon?: AppIcons;
}>;

export const BadgeIcon = ({
  backgroundColor = 'Brand/200',
  iconColor = 'Colors/Foreground/fg-secondary',
  icon = 'File02',
}: BadgeIconProps) => {
  return (
    <Box sx={badgeIconSx(backgroundColor)}>
      <AppIcon iconName={icon} diameter={ICON_SIZES['24px']} color={iconColor} />
    </Box>
  );
};

const badgeIconSx =
  (backgroundColor: ColorToken): SxProps<Theme> =>
  ({ backrs }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: backrs.radius['radius-lg'],
    border: `2px solid ${backrs.colors['Gray/800']}`,
    backgroundColor: backrs.colors[backgroundColor],
    width: ICON_SIZES['56px'],
    maxWidth: ICON_SIZES['56px'],
    minWidth: ICON_SIZES['56px'],
    height: ICON_SIZES['56px'],
  });
